/* @flow */
// typecheck: ignore file
import Entity from 'lib/Entity';
import MessageDeliverySummary from 'entities/MessageDeliverySummary';

import type { DeliveryStatusType } from 'chat/constants/DeliveryConstants';

export default class MessageDelivery extends Entity {
  initialize() {
    this.idAttribute = 'message_uuid';
  }

  parse(response: Object) {
    if (response['read_summary']) {
      response['read_summary'] = new MessageDeliverySummary(response['read_summary']);
    }

    return response;
  }

  setReadSummaryState(state: DeliveryStatusType) {
    this.getReadSummary().setState(state);
  }

  getReadSummary(): MessageDeliverySummary {
    return this.get('read_summary');
  }
}



// WEBPACK FOOTER //
// ./src/entities/MessageDelivery.js